import { ICommit } from "@/apps/person-registration/shared-models/ICommit";
import { IImageFeedbackState } from "../models/IImageFeedbackState";

/**
 * ACTIONS
 */
const actions = {
  setUserLocation: ({ commit }: ICommit, payload: string): void => {
    commit("SET_USER_LOCATION", payload);
  },

  setUserType: ({ commit }: ICommit, payload: string): void => {
    commit("SET_USER_TYPE", payload);
  },

  setUserTag: ({ commit }: ICommit, payload: string): void => {
    commit("SET_USER_TAG", payload);
  },

  setVersionHash: ({ commit }: ICommit, payload: number): void => {
    commit("SET_VERSION_HASH", payload);
  },

  setPrivacyPolicyAccepted: ({ commit }: ICommit, payload: boolean): void => {
    commit("SET_PRIVACY_POLICY_ACCEPT", payload);
  },

  setHasFrontId: ({ commit }: ICommit, payload: boolean): void => {
    commit("SET_HAS_FRONT_ID", payload);
  },

  setHasBackId: ({ commit }: ICommit, payload: boolean): void => {
    commit("SET_HAS_BACK_ID", payload);
  },

  setHasSelfie: ({ commit }: ICommit, payload: boolean): void => {
    commit("SET_HAS_SELFIE", payload);
  },

  setInManualReview: ({ commit }: ICommit, payload: boolean): void => {
    commit("SET_IN_MANUAL_REVIEW", payload);
  },

  setPhoneVerification: (
    { commit }: ICommit,
    payload: {
      phoneNumber: string | null;
      previouslyVerifiedPhone: string | null;
      isPreviouslyVerifiedPhoneFound: boolean;
      registrantOptedToUsePreviouslyVerifiedPhone: boolean;
      isPhoneVerified: boolean;
    }
  ): void => {
    commit("SET_PHONE_VERIFICATION", payload);
  },

  setPhoneNumber: ({ commit }: ICommit, payload: string): void => {
    commit("SET_PHONE_NUMBER", payload);
  },

  setIsPhoneVerified: ({ commit }: ICommit, payload = true): void => {
    commit("SET_IS_PHONE_VERIFIED", payload);
  },

  registrantOptedToUsePreviouslyVerifiedEmail: (
    { commit }: ICommit,
    payload: string
  ): void => {
    commit("REGISTRANT_OPTED_TO_USE_PREVIOUSLY_VERIFIED_EMAIL", payload);
  },

  setEmailVerification: (
    { commit }: ICommit,
    payload: {
      email: string | null;
      previouslyVerifiedEmail: string | null;
      isPreviouslyVerifiedEmailFound: boolean;
      registrantOptedToUsePreviouslyVerifiedEmail: boolean;
      isEmailVerified: boolean;
    }
  ): void => {
    commit("SET_EMAIL_VERIFICATION", payload);
  },

  setEmail: ({ commit }: ICommit, payload: string): void => {
    commit("SET_EMAIL", payload);
  },

  setIsEmailVerified: ({ commit }: ICommit, payload = true): void => {
    commit("SET_IS_EMAIL_VERIFIED", payload);
  },

  registrantOptedToUsePreviouslyVerifiedPhone: (
    { commit }: ICommit,
    payload = true
  ): void => {
    commit("REGISTRANT_OPTED_TO_USE_PREVIOUSLY_VERIFIED_PHONE", payload);
  },

  setPasswordCreatedAt: ({ commit }: ICommit, payload: number): void => {
    commit("SET_PASSWORD_CREATED_AT", payload);
  },

  setPersonCreated: ({ commit }: ICommit, payload: boolean): void => {
    commit("SET_PERSON_CREATED", payload);
  },

  setMessagesBagFront: (
    { commit }: ICommit,
    payload: IImageFeedbackState
  ): void => {
    commit("SET_MESSAGES_BAG_FRONT", payload);
  },

  setMessagesBagBack: (
    { commit }: ICommit,
    payload: IImageFeedbackState
  ): void => {
    commit("SET_MESSAGES_BAG_BACK", payload);
  },

  setMessagesBagSelfie: (
    { commit }: ICommit,
    payload: IImageFeedbackState
  ): void => {
    commit("SET_MESSAGES_BAG_SELFIE", payload);
  },

  setMessagesBagBottomPage: (
    { commit }: ICommit,
    payload: IImageFeedbackState
  ): void => {
    commit("SET_MESSAGES_BAG_BOTTOM_PAGE", payload);
  },

  setMessagesBagCxCorrection: (
    { commit }: ICommit,
    payload: IImageFeedbackState
  ): void => {
    commit("SET_MESSAGES_BAG_CX_CORRECTION", payload);
  },

  setActionablePage: ({ commit }: ICommit, payload: string): void => {
    commit("SET_ACTIONABLE_PAGE", payload);
  },

  setSettings: ({ commit }: ICommit, payload: Array<string>): void => {
    commit("SET_SETTINGS", payload);
  },

  setExternalUrlAfterCompletion: (
    { commit }: ICommit,
    payload: string
  ): void => {
    commit("SET_EXTERNAL_URL_AFTER_COMPLETION", payload);
  },

  setCaptureFlow: ({ commit }: ICommit, payload: string): void => {
    commit("SET_CAPTURE_FLOW", payload);
  },

  setCaptureFlowCompleted: ({ commit }: ICommit, payload: string): void => {
    commit("SET_CAPTURE_FLOW_COMPLETED", payload);
  },

  setCountry: ({ commit }: ICommit, payload: string): void => {
    commit("SET_COUNTRY", payload);
  },

  setOriginatingCountry: ({ commit }: ICommit, payload: string): void => {
    commit("SET_ORIGINATING_COUNTRY", payload);
  },

  setIdentifications: ({ commit }: ICommit, payload: string): void => {
    commit("SET_IDENTIFICATIONS", payload);
  },

  setSkipEmailInput: ({ commit }: ICommit, payload: boolean): void => {
    commit("SET_SKIP_EMAIL_INPUT", payload);
  },

  setSkipPhonelInput: ({ commit }: ICommit, payload: boolean): void => {
    commit("SET_SKIP_PHONE_INPUT", payload);
  },

  setHideCancelButton: ({ commit }: ICommit, payload: boolean): void => {
    commit("SET_HIDE_CANCEL_BUTTON", payload);
  },

  setIncodeRedirectionUrl: ({ commit }: ICommit, payload: boolean): void => {
    commit("SET_INCODE_REDIRECTION_URL", payload);
  },
  setCxQueuePosition: ({ commit }: ICommit, payload: number): void => {
    commit("SET_CX_QUEUE_POSITION", payload);
  },
  setIsCxTicketAssigned: ({ commit }: ICommit, payload: boolean): void => {
    commit("SET_CX_TICKET_ASSIGNED", payload);
  },
};

export default actions;
